import { Message } from 'element-ui'
import { RequestError } from './request'

/**
 * 错误提示
 * @param error 错误信息
 * @param stopBubble 是否阻止冒泡，默认不阻止
 */
export function $error (error, stopBubble = false) {
  let message = '系统错误，请稍后再试！'
  if (typeof error === 'string') {
    // 接口返回的response的返回体的message信息
    message = error || '系统错误，请稍后再试！'
    Message({
      showClose: true,
      type: 'error',
      message,
      duration: 2000,
    })
  } else if (typeof error === 'object') {
    // 网络请求错误 | 代码错误
    message = error.message
    if (message === '401_UNAUTHORIZED') return
    if (message) {
      Message({
        showClose: true,
        type: 'error',
        message,
        duration: 2000,
      })
    }
  }
  // else if (typeof error === 'boolean') {
  //     message = '表单校验未通过，请检查输入项！'
  //   }
  // 如果不阻止错误冒泡，且不是网络错误，则向上抛出错误
  if (!stopBubble && !(error instanceof RequestError)) {
    throw error
  }
}

/**
 * 成功提示
 * @param success 成功信息
 * @param stopBubble 是否阻止冒泡，默认不阻止
 */
export function $success (success, stopBubble = false) {
  const message = success || '操作成功！'
  Message({
    showClose: true,
    type: 'success',
    message,
    duration: 1000,
  })
}

/**
 * 警告提示
 * @param warning 警告信息
 * @param stopBubble 是否阻止冒泡，默认不阻止
 */
export function $warn (warning, stopBubble = false) {
  const message = warning || '请注意'
  Message({
    showClose: true,
    type: 'warning',
    message,
    duration: 2000,
  })
}
